export const business = {
  name: 'los BROTHERS',
  phoneDisplay: '+1 (415) 368-4846',
  phoneHref: 'tel:+14153684846',
  whatsappHref: 'https://wa.me/14153684846',
  instagramHandle: '@cleaning10127',
  instagramHref: 'https://instagram.com/cleaning10127',
  instagramStats: { posts: 9, followers: 116, following: 12 },
  mapEmbed:
    'https://www.google.com/maps?q=San+Francisco+Bay+Area,+CA&z=10&output=embed',
}
